import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useContext, useEffect } from "react";
import { Question } from "../../../components/utils/CourseTree";
import { TempEventContext } from "../../../context/TempEventContext";
import { TempEventCtx } from "../../../interfaces";
import { MockProblemTitle } from "./MockProblemTitle";

const useStyles = makeStyles((theme) => ({
  mockPageContainer: {
    border: "none",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
    overflow: "hidden",
    position: "relative",
  },
  mockContainer: {
    display: "flex",
    width: "100%",
    overflowY: "auto",
    maxHeight: "100%",
  },
  content: {
    width: "100%",
    padding: "50px 55px",
    boxSizing: "border-box",
  },
}));

interface MockProblemContainerProps {
  currentQuestion: Question;
  children?: any;
}

/**
 * This component can be re-used as a standin for the Gradarius iFrame
 * When this loads the Solver iframe should be unmounted and this triggers
 * the "loaded" state to allow button clicks
 */
export const MockProblemContainer = ({
  currentQuestion,
  children,
}: MockProblemContainerProps) => {
  const classes = useStyles();
  const tempEventCtx = useContext(TempEventContext) as TempEventCtx;

  useEffect(() => {
    tempEventCtx.setIsSolverLoaded(true);
    return () => {
      // Anything in here is fired on component unmount.
      // reset to loaded so that buttons on top are usable
      tempEventCtx.setIsSolverLoaded(false);
    };
  }, [tempEventCtx]);

  return (
    <Box className={classes.mockPageContainer}>
      <Box className={classes.mockContainer}>
        <Box className={classes.content}>
          <MockProblemTitle title={currentQuestion.name} />
          {children}
        </Box>
      </Box>
    </Box>
  );
};
